export type AppliedRouteWeek = {
	dateString: string;
	departmentId: string;
	appliedIndex: number;
};

/** A bare `/staffing` URL names no date, so the next visit to a date is a fresh navigation. */
export function rememberedRouteWeek(dateString: string | undefined, previous: AppliedRouteWeek | null): AppliedRouteWeek | null {
	if (!dateString) return null;
	return previous;
}

/**
 * The week the route date should own, or null when the grid must stay where it is.
 *
 * Week arrows move the visible week without changing the route param. A later weeks reload
 * (Accept on a census replacement notice rebuilds that array) must not snap the grid back
 * to the route date. A new route date, a department switch, or weeks that have only just
 * become able to resolve the date still apply.
 */
export function resolveAppliedRouteWeek(
	previous: AppliedRouteWeek | null,
	current: { dateString: string; departmentId: string; weekIndex: number; calculatedWeekIndex: number },
): AppliedRouteWeek | null {
	if (current.calculatedWeekIndex < 0) return null;

	const sameRoute = previous !== null && previous.dateString === current.dateString && previous.departmentId === current.departmentId;
	if (sameRoute && current.weekIndex !== previous.appliedIndex) return null;

	return {
		dateString: current.dateString,
		departmentId: current.departmentId,
		appliedIndex: current.calculatedWeekIndex,
	};
}
